

import React, { memo } from 'react';

import { ROLE_MAP } from '@shootsta/common-domain-data';
import CollaboratorsList from './CollaboratorsList';
import { getFilteredRoles } from '../../../utils/getFilteredRoles';








const ignoringRoles = [
ROLE_MAP.NONE];


function MembersTab(props) {
  const { roles, members, onRemoveMember, onUpdateMember } = props;
  const filteredRoles = getFilteredRoles(roles, ignoringRoles);

  return (
    <CollaboratorsList
      roles={filteredRoles}
      listItems={members}
      onRemoveMember={onRemoveMember}
      onUpdateMember={onUpdateMember}
      type="members" />);


}

export default memo(MembersTab);